import { ButtonTypeEnum, PaymentOptions } from '@app/app.enum';
import CustomButton from '@app/components/shared/custom-button.component';
import * as models from '@app/models/index';
import Injector from '@app/services';
import { AccountService } from '@app/services/account.service';
import { IntlService } from '@app/services/intl.service';
import { Grid } from '@material-ui/core';
import React, { Component } from 'react';
import PaymentMethodComponent from '../../purchase-postage/payment-method.component';

const intlService: IntlService = Injector.get(IntlService);
const accountService: AccountService = Injector.get(AccountService);

class PaymentMethodStepperComponent extends Component<
	models.IPaymentMethodStepperComponentProps,
	models.IPaymentMethodStepperComponentState
> {
	constructor(props: models.IPaymentMethodStepperComponentProps) {
		super(props);
		this.state = {
			loading: false,
			isNewDetails: !props.paymentInfo.method,
		};
	}

	public componentDidMount() {
		if (this.props?.paymentInfo?.method === PaymentOptions.None) {
			this.setState({
				isNewDetails: true,
			});
		}
	}

	public componentDidUpdate(
		prevProps: models.IPaymentMethodStepperComponentProps,
		prevState: models.IPaymentMethodStepperComponentState
	) {
		if (prevProps.paymentInfo?.method !== this.props.paymentInfo?.method) {
			this.setState({
				isNewDetails: !this.props.paymentInfo.method,
			});
		}
	}

	public render() {
		const { method, details } = this.props.paymentInfo;

		return (
			<PaymentMethodComponent
				isForQuickSignUp={this.state.isNewDetails}
				hideNoPaymentScreen={true}
				paymentMethodData={{
					isUpdate: this.state.isNewDetails,
					prefilledData: details,
					defaultMethod: method,
					prefilledPaymentMethod: method,
					onUpdateCb: (value: boolean, paymentMethod?: PaymentOptions) => {
						this.setState({
							isNewDetails: value,
						});
					},
				}}
				formButtons={(
					onSubmit: (reqAuthHeader: string, callback: () => Promise<void>) => Promise<void>,
					onCancel: () => void,
					onUpdate: () => void
				) => {
					return this.formButtons(onSubmit, onCancel, onUpdate);
				}}
			/>
		);
	}

	private getPaymentDetails = async (accessToken: string): Promise<[PaymentOptions, models.IPaymentValueSetUp]> => {
		try {
			const result = await accountService.getAccountDetails(null, accessToken);
			let paymentDetails: models.IPaymentValueSetUp = null;
			const defaultPaymentCheck = result?.creditCardPaymentAccountResponse?.default
				? PaymentOptions.CreditCard
				: result?.achPaymentAccountResponse?.default
				? PaymentOptions.ACH
				: PaymentOptions.None;

			// Setting payment details
			if (result.creditCardPaymentAccountResponse) {
				paymentDetails = {
					cardHolderName: result.creditCardPaymentAccountResponse.cardHolderName,
					expirationMonth: result.creditCardPaymentAccountResponse.expirationMonth,
					expirationYear: result.creditCardPaymentAccountResponse.expirationYear,
					lastFourCredit: result.creditCardPaymentAccountResponse.lastFour,
				};
			}
			if (result.achPaymentAccountResponse) {
				paymentDetails = {
					...paymentDetails,
					accountHolderName: result.achPaymentAccountResponse.accountHolderName,
					lastFourAccount: result.achPaymentAccountResponse.lastFour,
					routingNumber: result.achPaymentAccountResponse.routingNumber,
				};
			}

			return [defaultPaymentCheck, paymentDetails];
		} catch (error) {
			throw error;
		}
	};

	private formButtons = (
		onSubmit: (reqAuthHeader: string, callback: () => Promise<void>) => Promise<void>,
		onCancel: () => void,
		onUpdate: () => void
	) => {
		if (!!this.props.paymentInfo.method) {
			return (
				<Grid container={true} spacing={3} justifyContent='center' alignItems='center'>
					{this.props.paymentInfo.method !== PaymentOptions.None &&
						(this.state.isNewDetails ? (
							<Grid item={true}>
								<CustomButton
									type={ButtonTypeEnum.Button}
									onClick={() => onCancel()}
									buttonText={intlService.GetFormattedMessage('app.common.dialog-cancel-button-text')}
								/>
							</Grid>
						) : (
							<Grid item={true}>
								<CustomButton
									type={ButtonTypeEnum.Button}
									onClick={() => {
										onUpdate();
										this.setState({
											isNewDetails: true,
										});
									}}
									buttonText={intlService.GetFormattedMessage('app.billing.auto-buy-update-button-text')}
								/>
							</Grid>
						))}
					<Grid item={true}>
						<CustomButton
							type={ButtonTypeEnum.Button}
							onClick={() => {
								if (this.state.isNewDetails) {
									this.updatePaymentInfo(onSubmit);
									return;
								}
								this.props.onNext();
							}}
							loading={this.state.isNewDetails && this.state.loading}
							disabled={this.state.isNewDetails && this.state.loading}
							buttonText={intlService.GetFormattedMessage('app.app-view.next-button')}
						/>
					</Grid>
				</Grid>
			);
		}

		return (
			<Grid container={true} justifyContent='center' alignItems='center'>
				<Grid item={true}>
					<CustomButton
						buttonText={intlService.GetFormattedMessage('app.app-view.next-button')}
						type={ButtonTypeEnum.Button}
						loading={this.state.loading}
						disabled={this.state.loading}
						onClick={() => this.updatePaymentInfo(onSubmit)}
					/>
				</Grid>
			</Grid>
		);
	};

	private paymentMethodInfoCb = async () => {
		const { accessToken, onSuccess } = this.props;
		const [paymentMethod, paymentDetails] = await this.getPaymentDetails(accessToken);
		this.setState({
			loading: false,
		});
		onSuccess(paymentMethod, paymentDetails);
	};

	private updatePaymentInfo = async (
		onSubmit: (reqAuthHeader: string, callback: () => Promise<void>) => Promise<void>
	) => {
		try {
			const { accessToken } = this.props;
			this.setState({
				loading: true,
			});
			await onSubmit(accessToken, this.paymentMethodInfoCb);
		} catch (err) {
			this.setState({
				loading: false,
			});
		}
	};
}

export default PaymentMethodStepperComponent;



// WEBPACK FOOTER //
// ./src/components/account/signup/quick/payment-method-stepper.component.tsx